import Script from 'next/script'
import React from 'react'

/** Olamee marketing GTM container — owns GA4 and the Google Ads trial-signup conversion. */
const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_ID

function Scripts() {
    return (
        <>
            <Script src="https://accounts.google.com/gsi/client" strategy="beforeInteractive" />

            {process.env.NEXT_PUBLIC_ENVIRONMENT_MODE === 'production' && GTM_CONTAINER_ID && <Script id="google-tag-manager" strategy="afterInteractive">
                {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');
        `}
            </Script>}


            {/* <Script strategy="afterInteractive" src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}`} />

            
            <Script strategy="afterInteractive" id="google-analytics">
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
 
          gtag('config', "${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}");
        `}
            </Script>
            {process.env.NEXT_PUBLIC_ENVIRONMENT_MODE && process.env.NEXT_PUBLIC_ENVIRONMENT_MODE === 'production' && <Script id="inspect-let-analytics" type="text/javascript">
                {`
        (function() {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 954949439]);
          var ldinsp = function(){
          if(typeof window.__inspld != "undefined") return; 
          window.__inspld = 1;
          var insp = document.createElement('script'); 
          insp.type = 'text/javascript';
          insp.async = true; 
          insp.id = "inspsync";
          insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=954949439&r=' + Math.floor(new Date().getTime()/3600000);
          var x = document.getElementsByTagName('script')[0]; 
          x.parentNode.insertBefore(insp, x); };
          setTimeout(ldinsp, 0);
          })();
        `}
            </Script>} */}

        </>
    )
}

export default Scripts